<script>
export default {
  props: {
    vertical: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    wrapperClass() {
      return {
        'lego-validator--error': this.hasError === true,
        'lego-validator--valid': this.showValid && this.hasError === false,
        'lego-validator--shake': this.shake,
        'lego-checkbox-wrapper--vertical': this.vertical
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.lego-checkbox-wrapper {
  .lego-checkbox--medium + .lego-checkbox--medium {
    margin-left: $lego-checkbox-wrapper__margin-left--medium !important;
  }
}

.lego-checkbox-wrapper--vertical {
  .lego-checkbox + .lego-checkbox {
    margin-top: $lego-checkbox-wrapper__vertical__margin;
    margin-left: 0;
  }

  .lego-checkbox {
    width: 100%;
  }
}
</style>
